import React from 'react';
import { Anchor, Card, DetailedIconPrivacy, Heading, Paragraph } from '@zillow/constellation';
import { LANDLORD_SCREENING_FAQ, PRIVACY_POLICY, RENTER_SCREENING_FAQ } from '../constants/urls';
import { useTermSet } from '../contexts/IdVerificationContext';
import { TermSet } from '../../../models';

function LandlordContent() {
  return (
    <>
      <Heading level={6} as="h2" marginBottom="sm">
        How your user data is handled
      </Heading>
      <Paragraph marginBottom="md">
        Verifying your identity is an important part of protecting your rental applicants’ data.
      </Paragraph>
      <Paragraph marginBottom="md">
        We’ll only ask as many question as needed to verify your identity. Your answers are securely passed to Experian
        and CIC without being stored by Zillow, and with no impact to your credit score.
      </Paragraph>
      <Paragraph>
        See our{' '}
        <Anchor href={PRIVACY_POLICY} target="_blank">
          privacy policy
        </Anchor>{' '}
        and{' '}
        <Anchor href={LANDLORD_SCREENING_FAQ} target="_blank">
          FAQ
        </Anchor>{' '}
        for more details.
      </Paragraph>
    </>
  );
}

function RenterContent() {
  return (
    <>
      <Heading level={6} as="h2" marginBottom="sm">
        Protecting your data
      </Heading>
      <Paragraph marginBottom="md">
        We only share your credit and background check reports with identity-verified rental managers.
      </Paragraph>
      <Paragraph marginBottom="md">
        We limit our questions to what’s needed to create these reports. Your answers are securely passed to Experian
        and CIC without being stored by Zillow.
      </Paragraph>
      <Paragraph>
        See our{' '}
        <Anchor href={PRIVACY_POLICY} target="_blank">
          privacy policy
        </Anchor>{' '}
        and{' '}
        <Anchor href={RENTER_SCREENING_FAQ} target="_blank">
          FAQ
        </Anchor>{' '}
        for more details.
      </Paragraph>
    </>
  );
}

export default function PrivacyCard() {
  const termSet = useTermSet();

  return (
    <Card cardType="secondary" cardElevation={0} marginLeft={{ xl: 'xl' }}>
      <DetailedIconPrivacy size="lg" marginBottom="sm" />
      {termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />}
    </Card>
  );
}
